import React, { Fragment, useState } from 'react';
import { Modal as AntModal, Button, Form, message, Upload, Icon } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

const api = services.api;
type beforeUploadType = (file: any) => Promise<void>;

const BatchShipment = (props: any) => {
    const { form, entity, row } = props;
    const [visible, setVisible] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<any>([]);

    // 获取默认图片
    const onShow = () => {
        api.get({}, { apiPath: `/live/room/default_img` })
            .then((res: any) => {
                setFileList([{ uid: 1, url: res.data }]);
                message.success('默认图片获取成功');
                setVisible(true);
            })
            .catch(errorHandle);
    };

    // 保存
    const onSave = (e) => {
        e.preventDefault();
        if (fileList.length === 0) return;

        console.log(fileList);

        const params = {
            img_url: fileList[0].url || fileList[0].response.path,
        };

        api.post(params, { apiPath: `/live/room/recommend/${props.row.roomid}` })
            .then(() => {
                setVisible(false);
                message.success('设置成功');
                // 列表数据刷新
                entity.search({
                    ...entity.params,
                    ...entity.filters,
                });
            })
            .catch(errorHandle);
    };

    const handlePreview = async (e: any) => {
        setPreviewImage(e.url || e.thumbUrl);
        setShowPreview(true);
    };

    const handleChange = (e: any) => {
        if (e.file.status === 'done') {
            message.success('上传成功1个，上传失败0个');
        } else if (e.file.status === 'error') {
            message.success('上传成功0个，上传失败1个');
        }

        setFileList(e.fileList);
    };

    const handleBeforeUpload: beforeUploadType = (file) => {
        return new Promise((resolve, reject) => {
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                message.error(`图片${file.name}超出限制，最大上传 10MB 图片`);
                setFileList([]);
                reject();
            } else {
                resolve(file);
            }
        });
    };

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">上传</div>
        </div>
    );

    const emptyFileList = (
        <span style={{ color: '#f5222d', marginTop: '2px', marginBottom: '-5px' }}>
            图片为必填项
        </span>
    );

    const uploadMsg = (
        <>
            <span>最多上传 1 张</span>
            <br />
            <span>建议尺寸: 60px * 60px 支持格式PNG GIF</span>
            <br />
        </>
    );

    return (
        <Fragment>
            {row.recommend === 'NOT_RECOMMEND' && (
                <Button type="link" onClick={onShow}>
                    设为推荐
                </Button>
            )}
            <AntModal
                visible={visible}
                title={'设为首页推荐'}
                onCancel={() => {
                    setVisible(false);
                }}
                onOk={onSave}
                mask
                width={700}
            >
                <Form layout="vertical">
                    <Form.Item label="icon图标">
                        {form.getFieldDecorator('imgUrl', { rules: [{ required: true }] })(
                            <Upload
                                accept="image/*"
                                name="fileName"
                                action={`${ENV.API_ROOT}/images`}
                                listType="picture-card"
                                fileList={fileList}
                                beforeUpload={handleBeforeUpload}
                                onPreview={handlePreview}
                                onChange={handleChange}
                            >
                                {fileList.length >= 1 ? null : uploadButton}
                            </Upload>
                        )}
                        {uploadMsg}
                        {fileList.length === 0 && emptyFileList}
                    </Form.Item>
                </Form>
            </AntModal>

            <AntModal
                visible={showPreview}
                footer={null}
                width={500}
                style={{ textAlign: 'center' }}
                onCancel={() => {
                    setShowPreview(false);
                    setPreviewImage('');
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <img style={{ width: '100%' }} src={previewImage} alt="" />
                </div>
            </AntModal>
        </Fragment>
    );
};

export const BatchShipmentPage = Form.create()(BatchShipment);
